import { useAgTechAuthContext } from "@agtech/core/auth/AgTechAuthContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AgTechWebAppLoginHandler = () => {
    let authContext = useAgTechAuthContext();
    let navigate = useNavigate();

    useEffect(() => {
        authContext.onSuccessfulUserLogin({
            navigateToRoot: () => {
                navigate('/app/home');
            }
        });
    }, []);

    return (<></>)
};

export default AgTechWebAppLoginHandler;